import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import config from '../../config';
import Title from './title';

const SuperAdminUsers = () => {
  const user = useSelector(state => state.user.currentUser);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Фильтры пользователей
  const [userFilters, setUserFilters] = useState({
    role: '',
    search: '',
    page: 1
  });

  const loadUsers = useCallback(async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (userFilters.role) params.append('role', userFilters.role);
      if (userFilters.search) params.append('search', userFilters.search);
      params.append('page', userFilters.page);

      const res = await axios.get(`${config.apiUrl}/api/superadmin/users?${params}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setUsers(res.data.users);
    } catch (error) {
      console.error('Ошибка загрузки пользователей:', error);
    } finally {
      setLoading(false);
    }
  }, [userFilters]);

  useEffect(() => {
    if (user?.role === 'super_admin') {
      loadUsers();
    }
  }, [user, userFilters, loadUsers]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChangeUserRole = async (userId, newRole, companyId = null) => {
    try {
      await axios.put(`${config.apiUrl}/api/superadmin/users/${userId}/role`, {
        role: newRole,
        companyId
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      alert('Роль пользователя изменена успешно!');
      loadUsers();
    } catch (error) {
      console.error('Ошибка изменения роли:', error);
      alert('Ошибка изменения роли пользователя');
    }
  };

  if (loading) {
    return (
      <div className="my-cargo mainAdmin">
        <Title text="Все пользователи" />
        <div className="loadpage">
          <p>Загрузка...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="my-cargo mainAdmin">
      <Title text="Все пользователи" />

      <div className="section-my-cargo">
        <div style={{ width: '100%', padding: '20px' }}>
          <div style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
              <select
                value={userFilters.role}
                onChange={(e) => setUserFilters({ ...userFilters, role: e.target.value })}
                style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
              >
                <option value="">Все роли</option>
                <option value="super_admin">Супер-админ</option>
                <option value="company_admin">Админ компании</option>
                <option value="filial">Админ филиала</option>
                <option value="user">Пользователь</option>
              </select>
              <input
                type="text"
                placeholder="Поиск по имени, фамилии или телефону"
                value={userFilters.search}
                onChange={(e) => setUserFilters({ ...userFilters, search: e.target.value })}
                style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '4px', flex: 1 }}
              />
            </div>
          </div>

          <div className="users-list" style={{ display: 'grid', gap: '15px' }}>
            {users.map((userItem) => (
              <div key={userItem._id} className="user-card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px', border: '1px solid #ddd', borderRadius: '8px', background: '#f8f9fa' }}>
                <div className="user-info">
                  <h3>{userItem.name} {userItem.surname}</h3>
                  <p>Телефон: {userItem.phone}</p>
                  <p>Роль: {userItem.role}</p>
                  <p>Компания: {userItem.companyId ? 'Назначена' : 'Не назначена'}</p>
                  <p>Филиал: {userItem.filialId ? 'Назначен' : 'Не назначен'}</p>
                </div>
                <div>
                  <select
                    value={userItem.role}
                    onChange={(e) => handleChangeUserRole(userItem._id, e.target.value)}
                    style={{ padding: '6px', border: '1px solid #ddd', borderRadius: '4px', marginRight: '10px' }}
                  >
                    <option value="user">Пользователь</option>
                    <option value="filial">Админ филиала</option>
                    <option value="company_admin">Админ компании</option>
                    <option value="super_admin">Супер-админ</option>
                  </select>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminUsers;